import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Pagination from 'react-js-pagination'

// styles
import colors from '../../styles/colors'

// images
import FirstImg from '../../assets/image/pagination/ic-arrow-first.svg'

const Paging = ({
  page,
  count,
  setPage,
  isTemp,
  tableSize,
  marginTop, // 페이지네이션 상단 마진 [PC, Mobile]
  paginator,
}) => {
  const [size, setSize] = useState(window.innerWidth)

  const handleResize = () => {
    setSize(window.innerWidth)
  }

  useEffect(() => {
    // console.log('count', count)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // 페이지네이션(통계 페이지 - 리스트)
  // isTemp, tableSize 추가
  // 임시
  if (isTemp) {
    return (
      <Container marginTop={marginTop}>
        <Pagination
          activePage={page} //현재페이지
          itemsCountPerPage={tableSize} // 한 페이지당 보여줄 아이템 수 (올림 수 )
          totalItemsCount={count} // 총 아이템 수
          pageRangeDisplayed={size <= 480 ? 5 : 10} // paginator에서 보여줄 페이지 범위
          // pageRangeDisplayed={Math.ceil(count / tableSize)} // paginator에서 보여줄 페이지 범위
          prevPageText={'<'}
          nextPageText={'>'}
          onChange={setPage} //페이지가 바뀔 때 핸들링하는 함수
        />
      </Container>
    )
  } else {
    // 기존
    return (
      <Container marginTop={marginTop}>
        <Pagination
          activePage={page} //현재페이지
          itemsCountPerPage={tableSize} // 한 페이지당 보여줄 아이템 수 (올림 수) 10개
          totalItemsCount={count} // 총 아이템 수
          pageRangeDisplayed={
            size <= 480
              ? Math.min(5, Math.ceil(count / tableSize))
              : Math.min(10, Math.ceil(count / tableSize))
          } // paginator에서 보여줄 페이지 범위
          // pageRangeDisplayed={Math.ceil(count / tableSize)} // paginator에서 보여줄 페이지 범위
          prevPageText={'<'}
          nextPageText={'>'}
          onChange={setPage} //페이지가 바뀔 때 핸들링하는 함수
        />
      </Container>
    )
  }
}

export default Paging

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  /* position: relative; */
  margin-top: ${(props) =>
    props.marginTop[0] ? `${props.marginTop[0]}px` : '0px'};

  @media ${(props) => props.theme.mobile} {
    margin-top: ${(props) =>
      props.marginTop[1] ? `${props.marginTop[1]}px` : '0px'};
  }

  .pagination {
    display: flex;
    justify-content: center;
  }

  ul.pagination li a {
    text-decoration: none;
    color: ${colors.BK};
  }

  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    margin: 0 4px;
  }

  ul.pagination li.active {
    background-color: ${colors.mainG};
    width: 30px;
    height: 30px;
    border-radius: 15px;
  }

  ul.pagination li.active a {
    color: ${colors.W1};
  }

  // arrow
  ul.pagination li a {
    text-decoration: none;
  }

  ul.pagination li:first-child {
    width: 12px;
  }

  ul.pagination li:nth-child(2) {
    width: 14px;
    margin-right: 10px;
  }

  ul.pagination li:last-child {
    width: 14px;
  }

  ul.pagination li:nth-last-child(2) {
    width: 14px;
    margin-left: 10px;
  }

  /* ul.pagination .disabled a:hover {
    color: #6c757d;
    cursor: unset;
  } */

  ul.pagination .disabled a {
    color: ${colors.G2};
  }
`
